import { PlatformService } from '@core/services/platform.service';
import { HttpClient } from '@angular/common/http';
import { CaseQueueService } from '@products/dmepos/services/case-queue.service';
import { ServiceLineQueueService } from '@products/pac/services/service-line-queue.service';
import { ProductName } from '@core/constants';

export default (platformService: PlatformService, http: HttpClient) => {
  switch (platformService.currentProduct.value) {
    case ProductName.DMEPOS_MA:
    case ProductName.DMEPOS_MCD:
      return new CaseQueueService(platformService, http);
    default:
      return new ServiceLineQueueService(platformService, http);
  }
};
